import { REVIEWS } from "@/data";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { Stars, ReviewCard, GoogleLink, GoogleMark } from "@/components/Testimonials";
import { useSEO } from "@/hooks/useSEO";
import { BookButton } from "@/components/Buttons";
import { Reveal } from "@/components/Reveal";

export default function TestimonialsPage() {
  useSEO({
    title: "Patient Reviews | Glebe Park Dental, Canberra City",
    description: "What Canberra locals say about Glebe Park Dental — real Google reviews from patients of Dr Avantica Gupta and the team on Coranderrk Street.",
    path: "/testimonials",
  });
  return (
    <main className="bg-cream">
      <Nav />
      <section className="bg-sage pb-20 pt-40">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-16">
          <Reveal>
            <p className="font-mono text-xs tracking-[0.3em] uppercase text-leafmute">Kind words</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h1 className="mt-5 max-w-3xl font-serif text-4xl leading-[1.1] tracking-tight text-ink sm:text-5xl lg:text-6xl">
              Don't take <span className="italic text-fern">our word for it.</span>
            </h1>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <Stars size="h-5 w-5" />
              <p className="flex items-center gap-2 font-sans text-sm text-fern">
                <GoogleMark /> Google reviews from patients all over Canberra
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="py-20 lg:py-28">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-6 px-5 sm:px-8 md:grid-cols-2 lg:grid-cols-3 lg:gap-8 lg:px-16">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={0.08 * (i % 3)} y={24}>
              <ReviewCard r={r} />
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-12 text-center">
          <GoogleLink testid="testimonials-page-google-link" />
        </Reveal>
      </section>

      <section className="border-t border-ink/10 bg-sage py-20">
        <div className="mx-auto flex max-w-7xl flex-col items-start gap-8 px-5 sm:px-8 lg:flex-row lg:items-center lg:justify-between lg:px-16">
          <Reveal>
            <h2 className="font-serif text-3xl tracking-tight text-ink sm:text-4xl">
              Fancy joining them? <span className="italic text-fern">Come say hi.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <BookButton testid="testimonials-book-button" />
          </Reveal>
        </div>
      </section>
      <Footer />
    </main>
  );
}
